import { createClient } from '@supabase/supabase-js';
const URL = 'https://dumsxexagvzjplwjwjum.supabase.co';
const KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR1bXN4ZXhhZ3Z6anBsd2p3anVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE4NjgwNzIsImV4cCI6MjA4NzQ0NDA3Mn0.krFx2byhm18tAEymmW-ms8LKT51sLN5Of7vzTzT-lJ4';
export const supabase = createClient(URL, KEY);

// Campos que manda Transfermarkt (tm/README.md → "Política de prioridad"). Para un jugador
// sincronizado (tm_id presente y auto-sync ON) la app NO los escribe: así una sesión vieja
// no pisa lo que el sync ya actualizó (pasó con Carrizo el 2026-10-07 al cambiarle la foto).
export const TM_MANAGED_FIELDS = ['foot', 'height', 'birth_date', 'birth_year', 'position', 'position2', 'nationality', 'nationality2', 'nationality3', 'market_value', 'contract_expiry'];
export function isTmManaged(p) { return !!(p && p.tmId) && p.tmSyncEnabled !== false; }

// camelCase <-> snake_case mappers
export function toRow(p) {
  const row = toRowFull(p);
  if (isTmManaged(p)) for (const k of TM_MANAGED_FIELDS) delete row[k];
  return row;
}
function toRowFull(p) {
  return {
    id: p.id,
    first_name: p.firstName,
    last_name: p.lastName,
    club: p.club,
    category: p.category,
    position: p.position,
    nationality: p.nationality || 'Argentina',
    nationality2: p.nationality2 || null,
    nationality3: p.nationality3 || null,
    position2: p.position2 || null,
    phone: p.phone || null,
    birth_year: p.birthYear ? parseInt(p.birthYear, 10) : null,
    agent: p.agent || null,
    is_caa: p.isCaa || false,
    caa_handler: p.caaHandler || null,
    mandate: p.mandate || false,
    signed: p.signed || false,
    rating: p.rating || 0,
    contact: p.contact || null,
    notes: p.notes || null,
    photo: p.photo || null,
    contract_expiry: p.contractExpiry || null,
    date_signed: p.dateSigned || null,
    birth_date: p.birthDate || null,
    watchlist: p.watchlist || false,
    boot_size: p.bootSize || null,
    footage_link: p.footageLink || null,
    footage_videos: p.footageVideos?.length ? p.footageVideos : null,
    loan_club: p.loanClub || null,
    market_value: p.marketValue || null,
    height: p.height || null,
    foot: p.foot || null,
    contract_status: p.contractStatus || null,
    salary: p.salary || null,
    tm_link: p.tmLink || null,
    wy_link: p.wyLink || null,
    gps_link: p.gpsLink || null,
    brand_contract: p.brandContract || null,
    agent2: p.agent2 || null,
    national_team: p.nationalTeam || false,
    national_team_cat: p.nationalTeamCat || null,
    national_team_country: p.nationalTeamCountry || null,
    profile_color: p.profileColor || null,
    pro_contract: p.proContract || false,
    release_clause: p.releaseClause || null,
    game_description: p.gameDescription || null,
    game_description_en: p.gameDescriptionEn || null,
    photo_full: p.photoFull || null,
    created_at: p.createdAt || new Date().toISOString(),
  };
}
// Estados: 'following' (siguiendo) | 'focus' (enfocar) | 'discarded'. Los valores viejos del pipeline se mapean.
export function normalizeContact(v) {
  if (!v) return '';
  if (v === 'contacted' || v === 'negotiating' || v === 'following') return 'following';
  if (v === 'focus' || v === 'discarded') return v;
  return '';
}
// Condiciones de salida: columnas de tm/sql/006_exit_conditions.sql. Se escriben aparte (exitRow) para que un
// esquema sin esas columnas no rompa el guardado del jugador.
export function exitRow(p) {
  return { exit_type: p.exitType || null, asking_price: p.askingPrice || null, exit_currency: p.exitCurrency || null, showcase_rights: p.showcaseRights === true ? true : p.showcaseRights === false ? false : null, showcase_amount: p.showcaseAmount || null, loan_fee: p.loanFee === true ? true : p.loanFee === false ? false : null, loan_fee_amount: p.loanFeeAmount || null, exit_notes: p.exitNotes || null };
}
export function fromRow(r) {
  return {
    id: r.id,
    firstName: r.first_name,
    lastName: r.last_name,
    club: r.club,
    category: r.category,
    position: r.position,
    nationality: r.nationality,
    nationality2: r.nationality2 || '',
    nationality3: r.nationality3 || '',
    position2: r.position2 || '',
    phone: r.phone || '',
    birthYear: r.birth_year || '',
    agent: r.agent || '',
    isCaa: r.is_caa,
    caaHandler: r.caa_handler || '',
    mandate: r.mandate,
    signed: r.signed,
    rating: r.rating || 0,
    contact: normalizeContact(r.contact),
    notes: r.notes || '',
    photo: r.photo || '',
    contractExpiry: r.contract_expiry || '',
    dateSigned: r.date_signed || '',
    birthDate: r.birth_date || '',
    watchlist: r.watchlist || false,
    bootSize: r.boot_size || '',
    footageLink: r.footage_link || '',
    footageVideos: r.footage_videos || [],
    loanClub: r.loan_club || '',
    marketValue: r.market_value || '',
    height: r.height || '',
    foot: r.foot || '',
    contractStatus: r.contract_status || '',
    salary: r.salary || '',
    tmLink: r.tm_link || '',
    wyLink: r.wy_link || '',
    gpsLink: r.gps_link || '',
    brandContract: r.brand_contract || '',
    agent2: r.agent2 || '',
    nationalTeam: r.national_team || false,
    nationalTeamCat: r.national_team_cat || '',
    nationalTeamCountry: r.national_team_country || '',
    profileColor: r.profile_color || '',
    proContract: r.pro_contract || false,
    releaseClause: r.release_clause || '',
    gameDescription: r.game_description || '',
    gameDescriptionEn: r.game_description_en || '',
    photoFull: r.photo_full || '',
    exitType: r.exit_type || '',
    askingPrice: r.asking_price || '',
    exitCurrency: r.exit_currency || '',
    showcaseRights: r.showcase_rights === true ? true : r.showcase_rights === false ? false : null,
    showcaseAmount: r.showcase_amount || '',
    loanFee: r.loan_fee === true ? true : r.loan_fee === false ? false : null,
    loanFeeAmount: r.loan_fee_amount || '',
    exitNotes: r.exit_notes || '',
    createdAt: r.created_at,
    // Transfermarkt sync (solo lectura en la app; las escribe tm/lib/updater.js).
    // No van en toRow(): el update parcial de la app no las toca.
    tmId: r.tm_id || '',
    tmUpdatedAt: r.tm_updated_at || '',
    tmSyncEnabled: r.tm_sync_enabled !== false,
    tmClub: r.tm_club || '',
    tmLeague: r.tm_league || '',
    tmClubCountry: r.tm_club_country || '',
    tmContractExpires: r.tm_contract_expires || '',
    tmMarketValueEur: r.tm_market_value_eur ?? null,
    tmMarketValueDate: r.tm_market_value_date || '',
    tmAgent: r.tm_agent || '',
    tmLastError: r.tm_last_error || '',
  };
}

// ── SCOUTING REPORTS ──────────────────────────────────────────────────────────
const SCOUT_KEYS = ["control","pase","regate","definicion","pieizq","pieder","velocidad","fisico","resistencia","aereo","vision","posicion","pressing","anticipacion","liderazgo","mentalidad","ofensivo","creatividad"];

export function toScoutRow(r) {
  const ratings = Object.fromEntries(SCOUT_KEYS.map(k => [k, r[k] || 0]));
  return {
    id: r.id,
    player_id: r.playerId,
    scout: r.scout || "",
    date: r.date || "",
    match: r.match || "",
    minutes: r.minutes || "",
    goals: r.goals || "",
    assists: r.assists || "",
    overall: r.overall || "",
    fortalezas: r.fortalezas || "",
    debilidades: r.debilidades || "",
    semaforo: r.semaforo || "",
    ratings,
    enabled_cats: r.enabledCats || {},
    created_at: r.createdAt || new Date().toISOString(),
  };
}

export function fromScoutRow(r) {
  return {
    id: r.id,
    playerId: r.player_id,
    scout: r.scout || "",
    date: r.date || "",
    match: r.match || "",
    minutes: r.minutes || "",
    goals: r.goals || "",
    assists: r.assists || "",
    overall: r.overall || "",
    fortalezas: r.fortalezas || "",
    debilidades: r.debilidades || "",
    semaforo: r.semaforo || "",
    enabledCats: r.enabled_cats || {},
    ...(r.ratings || {}),
    createdAt: r.created_at || "",
  };
}
